/**
 * @ngdoc service
 * @name ims.shared.data.service:tagCollection
 * @description
 * A collection of ims ZoneHistory objects. It handles loading and refreshing data.
 *
 */
import { ImsObjectIncrementalCollection } from './ims_object_incremental_collection.service';
import { TagResource } from '../resources';
import { Tag } from './tag';
import { ViewStateService } from 'app/shared/view_state.service';
import { IIntervalService, IRootScopeService } from 'angular';
import { SiteStateService } from '../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

export default class TagCollection extends ImsObjectIncrementalCollection {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope: IRootScopeService,
        $interval: IIntervalService,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            TagResource,
            Tag,
        );
    }
}
